<template>
    <div class="header-container">
        <div class="header-breadcrumb">
            <span class="breadcrumb-app">TAP</span>
            <span class="breadcrumb-sep">/</span>
            <span class="breadcrumb-page">{{ currentPageName }}</span>
        </div>
        <div class="header-right">
            <div v-if="user.isAuthenticated" class="header-user">
                <div class="header-user-avatar">
                    {{ userInitials }}
                </div>
                <span class="header-user-name">{{ user.userName }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import { useSettings } from '@/store/user';
import { useRoute } from 'vue-router';
import { computed } from 'vue';

export default {
    name: 'app-nav',
    setup() {
        const user = useSettings();
        const route = useRoute();

        const currentPageName = computed(() => {
            const name = route.name || '';
            if (name === 'home' || name === 'overview') return 'Dashboard';
            return String(name).replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
        });

        const userInitials = computed(() => {
            if (!user.userName) return '?';
            return user.userName.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
        });

        return { user, currentPageName, userInitials }
    },
};
</script>

<style scoped>
.header-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 100%;
}

.header-breadcrumb {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-family: 'IBM Plex Mono', monospace;
    font-size: 0.8125rem;
}

.breadcrumb-app {
    color: #a63c3c;
    font-weight: 500;
}

.breadcrumb-sep {
    color: #5c6370;
}

.breadcrumb-page {
    color: #9aa0a8;
    text-transform: capitalize;
}

.header-right {
    display: flex;
    align-items: center;
    gap: 1rem;
}

.header-user {
    display: flex;
    align-items: center;
    gap: 0.625rem;
}

.header-user-avatar {
    width: 30px;
    height: 30px;
    border-radius: 8px;
    background: rgba(117, 35, 35, 0.15);
    border: 1px solid rgba(117, 35, 35, 0.2);
    color: #a63c3c;
    font-family: 'IBM Plex Sans', system-ui, sans-serif;
    font-weight: 600;
    font-size: 0.6875rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

.header-user-name {
    font-size: 0.8125rem;
    color: #9aa0a8;
    font-weight: 500;
}
</style>
